// extracted by mini-css-extract-plugin
export default {"container":"Subjects_container__+RMT3","semester":"Subjects_semester__R6vkJ"};